export default [
    {
        path: 'complaint-agiliza/confirm/:complaint_id',
        component: ()=>import('@/views/customer/complaint-agiliza/Confirm.vue'),
        meta: {
            breadcrumb: [
                {label: 'Inicio', link: '/'},
                {label: 'Seguimiento', link:'/customer/complaint/tracking/'},
                {label: 'Confirmar'},
            ]
        }
    }
]